// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header__cL_5e","chevron":"styles__chevron__1WH6_","headerText":"styles__headerText__adpQM","content":"styles__content__1qIBM","separator":"styles__separator__XMFWc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Collapse/styles.css
// module id = 2174
// module chunks = 0